import { forwardRef, useState } from 'react'
import PrivacyPolicy from './PrivacyPolicy'
import './Footer.css'

interface FooterProps {}

const Footer = forwardRef<HTMLDivElement, FooterProps>((_props, ref) => {
  const currentYear = new Date().getFullYear()
  const [privacyOpen, setPrivacyOpen] = useState(false)

  return (
    <footer
      ref={ref}
      className="footer"
      role="contentinfo"
    >
      <div className="container">
        <div className="footer__grid grid grid--3">
          <div className="footer__brand">
            <h2 className="footer__logo">Catarina Malmberg</h2>
          </div>

          <nav className="footer__nav" aria-label="Fotnavigering">
            <h3 className="footer__nav-title">Navigera</h3>
            <ul className="footer__nav-list">
              <li><a href="#hero">Hem</a></li>
              <li><a href="#about">Om mig</a></li>
              <li><a href="#services">Behandlingar</a></li>
              <li><a href="#contact">Kontakt</a></li>
            </ul>
          </nav>

          <nav className="footer__nav" aria-label="Behandlingar">
            <h3 className="footer__nav-title">Behandlingar</h3>
            <ul className="footer__nav-list">
              <li><a href="#services">Samtalsbehandlingar</a></li>
              <li><a href="#services">Mindfulness</a></li>
              <li><a href="#services">ACT</a></li>
            </ul>
          </nav>

          <div className="footer__contact">
            <h3 className="footer__nav-title">Kontakt</h3>
            <address className="footer__address">
              <p><strong>Catarina Malmberg</strong><br />Psykodynamisk samtalsterapeut</p>
              <p>Terapi- och Friskvårdscentrum (Utsikt)<br />Spångatan 20 A<br />211 53 Malmö</p>
              <p>Tel: <a href="tel:+46733788272">0733-788272</a></p>
              <p>E-post: <a href="mailto:mail@catarinamalmberg.se">mail@catarinamalmberg.se</a></p>
            </address>
          </div>
        </div>

        <div className="footer__bottom">
          <p className="footer__copyright">
            &copy; {currentYear} Catarina Malmberg. Alla rättigheter förbehållna.
          </p>
          <nav className="footer__legal" aria-label="Juridiska länkar">
            <button
              type="button"
              className="footer__legal-btn"
              onClick={() => setPrivacyOpen(true)}
            >
              Integritetspolicy
            </button>
            <span aria-hidden="true">·</span>
            <a href="#contact">Kontakta mig</a>
          </nav>
        </div>
      </div>
      <PrivacyPolicy open={privacyOpen} onClose={() => setPrivacyOpen(false)} />
    </footer>
  )
})

Footer.displayName = 'Footer'

export default Footer